import PropTypes from 'prop-types';
import { Component } from 'react';
import Flux from '../../../flux/Flux';
import ProfileLiveShowSlider from './ProfileLiveShowSlider';
import '../../../../../src/VX/Asset/Less/VX/View/Actor/ProfileLiveShow.less';

class ProfileLiveShow extends Component {
	constructor(props) {
		super(props);

		this.state = {
			camShows: null,
			isMobile: this.isMobile(),
			initIndex: 0,
		};

		this.setHasStarted = this.setHasStarted.bind(this);
		this.isMobile = this.isMobile.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
		this.onOnlineStateChange = this.onOnlineStateChange.bind(this);
		this.onVisibilityChange = this.onVisibilityChange.bind(this);
		this.onChatTicketChange = this.onChatTicketChange.bind(this);
		this.onCamShowsChange = this.onCamShowsChange.bind(this);
		this.orderCamShows = this.orderCamShows.bind(this);
		this.loadData = this.loadData.bind(this);

		this.sliderRef = null;
	}

	componentDidMount() {
		Flux.Actor.addActorCamShowsChangeListener(this.onCamShowsChange);
		Flux.Browser.addWindowResizeListener(this.onWindowResize);
		Flux.Notification.addNotificationChangeListener(this.onOnlineStateChange);
		Flux.NewMessenger.addChatTicketChangeListener(this.onChatTicketChange);
		Flux.Browser.addVisibilityChangeListener(this.onVisibilityChange);

		this.loadData();
	}

	componentWillUnmount() {
		Flux.Actor.removeActorCamShowsChangeListener(this.onCamShowsChange);
		Flux.Browser.removeWindowResizeListener(this.onWindowResize);
		Flux.Notification.removeNotificationChangeListener(this.onOnlineStateChange);
		Flux.NewMessenger.removeChatTicketChangeListener(this.onChatTicketChange);
		Flux.Browser.removeVisibilityChangeListener(this.onVisibilityChange);
	}

	orderCamShows(ticketList) {
		if (ticketList && ticketList.length > 0) {
			const data = ticketList;
			const paramDate = this.getParamDate();
			let currentIndex = this.sliderRef ? this.sliderRef.currentIndex : this.state.currentIndex;
			if (paramDate) {
				const index = data.findIndex((item) => parseInt(new Date(item.start).getTime()) === parseInt(paramDate));
				currentIndex = index > -1 ? index : currentIndex;
			}
			this.setState({ camShows: data, hasStarted: data.hasStarted, initIndex: currentIndex });
		} else if (this.props.onNoDataFound) {
			this.props.onNoDataFound();
		}
	}

	onCamShowsChange() {
		const shows = Flux.Actor.getActorCamShows(this.props.actorId);
		shows ? this.orderCamShows(shows) : null;
	}

	onVisibilityChange(visible) {
		if (visible && this.state.camShows[this.sliderRef.state.currentIndex] && !this.state.hasStarted) {
			this.loadData();
		}
	}

	onChatTicketChange(result) {
		if (result && result.success && result.show.id === this.state.camShows[this.sliderRef.state.currentIndex].id) {
			Flux.NewMessenger.removeChatExitChangeListener(this.onChatTicketChange);
			this.loadData();
		}
	}

	onOnlineStateChange(notification) {
		const NotificationTypes = Flux.Constants.ApiTypes.Notification.Incoming;

		if (notification.actorId !== this.props.actorId) {
			return;
		}

		switch (notification.type) {
			case NotificationTypes.ACTOR_ONLINE:
				if (this.state.hasStarted !== notification.isLobbyChat) {
					this.loadData();
				}
				break;
			case NotificationTypes.ACTOR_OFFLINE:
				this.setState({
					hasStarted: false,
				});
				break;
		}
	}

	getParamDate() {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		if (urlParams.get('camsid')) {
			return urlParams.get('camsid');
		}
		return '';
	}

	loadData() {
		const shows = Flux.Actor.getActorCamShows(this.props.actorId);
		shows ? this.setState({ camShows: shows }) : Flux.Actor.loadActorCamShows(this.props.actorId);
	}

	setHasStarted(hasStarted) {
		if (hasStarted) {
			this.loadData();
		}
	}

	onWindowResize() {
		this.setState({ isMobile: this.isMobile() });
	}

	isMobile() {
		return this.props.isMobile || Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm;
	}

	render() {
		if (!this.state.camShows || this.state.camShows.length < 1 || !this.props.actorId) {
			return null;
		}

		return (
			<div className="profile-live-show__wrapper">
				<div className="profile-live-show__dots profile-live-show__dots--absolute"></div>
				<ProfileLiveShowSlider
					ref={(ref) => (this.sliderRef = ref)}
					initIndex={this.state.initIndex}
					data={this.state.camShows}
					isMobile={this.state.isMobile}
					loadData={this.loadData}
				/>
			</div>
		);
	}
}

ProfileLiveShow.propTypes = {
	actorId: PropTypes.number,
	previewPicture: PropTypes.string,
	onNoDataFound: PropTypes.func,
	isMobile: PropTypes.bool,
};

ProfileLiveShow.defaultProps = {
	previewPicture: '',
	isMobile: false,
};

export default ProfileLiveShow;
